import TextArea from 'devextreme-react/text-area';
import SelectBox from 'devextreme-react/select-box';
import Tabs from 'devextreme-react/tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { chamSocKhachHangApi } from "../../api/chamSocKhachHangApi";
import { chienDichApi } from '../../api/chienDichApi';
import { formItemApi } from '../../api/formItemApi';
import { formRegisterApi } from '../../api/formRegisterApi';
import { hocSinhApi } from '../../api/hocsinh_api';
import { phuHuynhApi } from '../../api/phuHuynhApi';
import { useCommonContext } from '../../contexts/common';
import { showNotify } from '../../helpers/toast';
import { DefaultButton, PrimaryButton } from "../editor/button";
import { FormGroup } from "../form-group";
import PhuHuynhCSKHItem from "../phu-huynh-cskh-item";
import PhuHuynhDKItem from "../phu-huynh-dk-item";
import styles from "./PhuHuynhCSKH.module.css";
import { useSelector } from 'react-redux';
const PhuHuynhCSKH = ({ ts_phuhuynh_id, ts_hocsinh_id, ts_hoso_survey_id }) => {
    const [chamSocKhachHangs, setChamSocKhachHangs] = useState([]);
    const [phuHuynh, setPhuHuynh] = useState({})
    const { dm_coso_id } = useSelector(x => x.coSo);
    // const [hoSoSurveys, setHoSoSurveys] = useState([])
    const [hocSinhs, setHocSinhs] = useState([])
    const [formData, setFormData] = useState({})
    const { translate } = useCommonContext();
    const componentDidMount = useRef(false)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [ts_form_items, set_ts_form_items] = useState([]);
    const [ts_form_register_results, set_ts_form_register_results] = useState([]);
    const [ts_form_register_result_details, set_ts_form_register_result_details] =
        useState([]);
    const tabs = [
        {
            id: 0,
            text: 'Lịch sử chăm sóc'
        },
        {
            id: 1,
            text: 'Lịch sử đăng ký'
        },
    ];
    useEffect(() => {
        componentDidMount.current = true;
        handleReloadData();
        return (() => {
            componentDidMount.current = false;
        })
    }, [ts_phuhuynh_id, ts_hocsinh_id, ts_hoso_survey_id])
    useEffect(() => {
        if (ts_phuhuynh_id > 0) {
            handleReloadHocSinhs();
            handleReloadPhuHuynh();
        }
        return (() => {
            componentDidMount.current = false;
        })
    }, [ts_phuhuynh_id, selectedIndex])

    const handleReloadData = async () => {
        const res = await chamSocKhachHangApi.Select({
            ts_phuhuynh_id,
            ts_hocsinh_id,
            ts_hoso_survey_id,
            dm_coso_id
        });

        if (componentDidMount.current) {
            if (res.is_success) {
                setChamSocKhachHangs(res.data);
            }
        }

    }
    // const handleReloadHoSoSurveys = async () => {
    //     const res = await hoSoSurveyApi.SelectByPhuHuynh(ts_phuhuynh_id);
    //     if (componentDidMount.current) {
    //         if (res.is_success) {
    //             setHoSoSurveys(res.data);
    //         }
    //     }
    // }
    const handleReloadHocSinhs = async () => {
        const res = await hocSinhApi.SelectByParent(ts_phuhuynh_id);
        if (componentDidMount.current) {
            if (res.is_success) {
                console.log(res.data );
                res.data = res.data.filter(x => x.dm_coso_id == dm_coso_id);
                console.log(res.data );
                setHocSinhs(res.data);
            }
        }
    }
    const handleReloadPhuHuynh = async () => {
        const res = await phuHuynhApi.Detail(ts_phuhuynh_id)
        if (componentDidMount.current) {
            if (res.is_success) {
                setPhuHuynh(res.data);
                // handleReloadFormItems(res.data.dm_chiendich_id);
                // handleReloadResults(res.data.dm_chiendich_id);
                // handleReloadResultDetails(res.data.dm_chiendich_id, res.data.dien_thoai)
            }
        }
    }
    const handleInsert = async () => {
        const res = await chamSocKhachHangApi.Insert({
            ...formData,
            ts_phuhuynh_id: ts_phuhuynh_id,
            dien_thoai: phuHuynh.dien_thoai,
            ten_khach_hang: phuHuynh.ho_ten,
            dm_coso_id: dm_coso_id
        });
        if (res.is_success) {
            showNotify({ text: "Thêm mới thành công", type: "success" });
            handleReloadData();
            setFormData({})

        } else {
            showNotify({ text: "Thêm mới thất bại", type: "error" });
        }
    }
    const cmbDataSource = useMemo(() => {
        let _source = [];
        hocSinhs.forEach(x => {
            _source.push({
                id: x.id,
                text: x.ho_ten
            })
        })
        return _source;
    }, [hocSinhs])

    const onTabsSelectionChanged = (args) => {

        if (args.name === 'selectedIndex') {
            if (args.value == 1) {
                setSelectedIndex(1);
            } else if (args.value == 0) {
                setSelectedIndex(0);
            }
            // 
        }
    }

    const handleReloadResults = async (dm_chien_dich_id) => {
        const res = await formRegisterApi.Select(dm_chien_dich_id);
        if (res.is_success) {
            set_ts_form_register_results(res.data);
        }
    };

    const handleReloadFormItems = async (dm_chiendich_id) => {
        const chien_dich = await chienDichApi.Detail(dm_chiendich_id);
        if (chien_dich.is_success) {
            const res = await formItemApi.Select(chien_dich.data.ts_form_id);
            if (res.is_success) {
                set_ts_form_items(res.data);
            }
        }

    };

    const handleReloadResultDetails = async (dm_chien_dich_id, phone_number) => {
        const res = await formRegisterApi.SelecDetailListByPhone(0, dm_chien_dich_id, phone_number);
        if (res.is_success) {
            set_ts_form_register_result_details(res.data);
        }
    };

    const dataSource = useMemo(() => {
        const source = ts_form_register_results.map((x) => {
            let item = { ...x };
            const details = ts_form_register_result_details.filter(
                (y) => y.ts_form_register_result_id == x.id
            );
            details.forEach((y) => {
                item[`T_${y.ts_form_item_id}`] = y.text;
                item['ten_chien_dich'] = phuHuynh.ten_chien_dich
                item['ho_ten'] = phuHuynh.ho_ten
            });
            return item;
        });
        const resutl = source.filter(
            (y) => y.phone_number == phuHuynh.dien_thoai
        );
        return resutl;
    }, [
        ts_form_items,
        ts_form_register_result_details,
        ts_form_register_results,
    ]);

    return (
        <>
            <div className={styles.container_form}>
                <div className={styles.caption}>Tiếp nhận yêu cầu</div>
                <div className='row'>
                    <div className='col-md-8'>
                        <FormGroup label={"Về việc"}>
                            <TextArea
                                stylingMode='underlined'
                                placeholder='Vui lòng điền nội dung tiếp nhận yêu cầu từ PH'
                                value={formData.noi_dung}
                                autoResizeEnabled
                                onValueChanged={(e) => { if (e.event) setFormData({ ...formData, noi_dung: e.value }) }}
                            />
                        </FormGroup>
                    </div>
                    <div className='col-md-4'>
                        {cmbDataSource.length >= 0 &&
                            <FormGroup label={"Chọn học sinh"}>
                                <SelectBox
                                    dataSource={cmbDataSource}
                                    displayExpr="text"
                                    valueExpr={"id"}
                                    stylingMode="underlined"
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            if (e.value < 0) {
                                                setFormData({ ...formData, ts_hoso_survey_id: -1 * e.value, ts_hocsinh_id: 0 })
                                            } else {
                                                setFormData({ ...formData, ts_hoso_survey_id: 0, ts_hocsinh_id: e.value })
                                            }
                                        }
                                    }}

                                />
                            </FormGroup>
                        }
                    </div>
                </div>

                <FormGroup label={"Ghi chú"}>
                    <TextArea stylingMode='underlined' placeholder='Điền ghi chú nếu cần thiết' autoResizeEnabled
                        onValueChanged={(e) => { if (e.event) setFormData({ ...formData, ghi_chu: e.value }) }}
                        value={formData.ghi_chu}
                    />
                </FormGroup>

                <div className={styles.actions}>
                    <DefaultButton text={"Đóng"} onClick={() => { setFormData({}) }} />
                    <PrimaryButton text={"Thêm yêu cầu"} onClick={handleInsert} />
                </div>
            </div>
            <div className={styles.container}>
                <Tabs
                    dataSource={tabs}
                    selectedIndex={selectedIndex}
                    onOptionChanged={(e) => {
                        onTabsSelectionChanged(e);
                    }}
                />
                <div className={styles.caption}></div>
                {chamSocKhachHangs.length == 0 && selectedIndex != 1 &&
                    <div className={styles.no_data}>
                        <p>{translate("Không có dữ liệu lịch sử chăm sóc")}</p>
                    </div>
                }
                {chamSocKhachHangs.length > 0 && selectedIndex != 1 &&
                    <div className={styles.list_container}>
                        {chamSocKhachHangs.map((ts_chamsockhachhang, idx) => {
                            return <PhuHuynhCSKHItem
                                key={idx}
                                ts_chamsockhachhang={ts_chamsockhachhang}
                                onChanged={handleReloadData}
                            />
                        })}
                    </div>
                }
                {selectedIndex == 1 &&
                    <div className={styles.list_container} style={{ height: "600px", background: "white", overflow: "auto" }}>
                        {dataSource.map((ts_dangky, idx) => {
                            return <PhuHuynhDKItem
                                key={idx}
                                ts_dangky={ts_dangky}
                                ts_form_items={ts_form_items}
                            />
                        })}
                    </div>
                }
            </div>
        </>
    );
};

export default PhuHuynhCSKH;